import SotbitCheckbox from '../default';
import { EVENTS } from '../constants';

/**
 * @attribute {string} target - A CSS selector for the checkboxes whose state
 * should be controlled by the select-all checkbox
 */

export default class SotbitSelectAllCheckbox extends SotbitCheckbox {
    static properties = {
        ...SotbitCheckbox.properties,
        target: { type: String },
    };

    constructor() {
        super();

        this.target = '';
        this._onTargetCheckboxChange = this._onTargetCheckboxChange.bind(this);
    }

    connectedCallback() {
        super.connectedCallback();

        document.addEventListener(EVENTS.CHANGE, this._onTargetCheckboxChange);
    }

    disconnectedCallback() {
        super.disconnectedCallback();

        document.removeEventListener(EVENTS.CHANGE, this._onTargetCheckboxChange);
    }

    getTargetCheckboxes() {
        try {
            return [...document.querySelectorAll(this.target)];
        } catch {
            return [];
        }
    }

    _isValidTargetCheckboxChangeEvent(event) {
        if (event.target === this || event.target.type !== 'checkbox') {
            return false;
        }

        try {
            if (!event.target.matches(this.target)) {
                return false;
            }
        } catch {
            return false;
        }

        return true;
    }

    _onTargetCheckboxChange(event) {
        if (!this._isValidTargetCheckboxChangeEvent(event)) {
            return;
        }

        const targetCheckboxes = this.getTargetCheckboxes();

        if (!targetCheckboxes.length) {
            return;
        }

        const allChecked = targetCheckboxes.every((checkbox) => {
            return checkbox.checked;
        });
        const allNotChecked = targetCheckboxes.every((checkbox) => {
            return !checkbox.checked;
        });

        this.checked = allChecked;
        this.indeterminate = !(allChecked || allNotChecked);
    }

    onChange(event) {
        super.onChange(event);

        this.setChecked(this.checked);
    }

    setChecked(checked) {
        checked = Boolean(checked);

        this.indeterminate = false;
        this.checked = checked;

        this.getTargetCheckboxes().forEach((checkbox) => {
            checkbox.checked = checked;
        });
    }
}
